export interface AppConfig {
  iosUrl?: string;
  androidUrl?: string;
}

export interface PaymentSetup {
  taxNumberInputLabel?: string;
  taxNumberRequiredMin?: number;
}

export interface NavbarLink {
  link: string;
  text: string;
}

export interface PlatformConfig {
  domain: string;
  api: string;
  token: string;
}

export interface Environment {
  production: boolean;
  sentryDsn: string;
  sentryEnvironment: string;
  sentryShowCrashReportDialog: boolean;
  seatsioWorkSpaceKey: string;
  platformConfigs: PlatformConfig[];
  stripeKey?: string;
  facebookPixelId?: string;
  teamPaymentOpensAtUtc?: string;
  teamPaymentOpensAtDubaiTime?: string;
  modules?: string[];
  navbarLinks?: NavbarLink[];
  paymentSetup?: PaymentSetup;
  chatbotUrl?: string;
  tiktokPixelId?: string;
  profileFields: string[];
}

export const baseEnv: Environment = {
  production: true,
  sentryDsn:
    'https://f94f3cd6dca4421d926b3ac224743d57@o82294.ingest.sentry.io/6677634',
  sentryEnvironment: 'production',
  sentryShowCrashReportDialog: false,
  seatsioWorkSpaceKey: '',
  platformConfigs: [],
  profileFields: ['date_of_birth', 'gender', 'nationality'],
};
